import React from "react";

export default function CommonButton({ name, width = "100%", onClick }) {
  return (
    <button
        className={"shopMoreButton"}
        onClick={onClick}
    >
      {name}
    </button>
  );
}
